import './HvacFormAspectRatioLabel.scss';
import React, { memo } from 'react';
import { AspectRatioIcon } from 'src/modules/common/icons/AspectRationIcon';
import { ChevronDownIcon } from 'src/modules/common/icons/ChevronDownIcon';
import { ChevronUpIcon } from 'src/modules/common/icons/ChevronUpIcon';

type Props = {
  readonly onOpen: () => void;
  readonly open: boolean;
};

export const HvacFormAspectRatioLabel = memo(({ onOpen, open }: Props) => (
  <button type="button" onClick={onOpen} className="bp-hvac-form-aspect-ratio-label">
    <AspectRatioIcon/>

    {open ? (<ChevronUpIcon/>) : (<ChevronDownIcon/>)}
  </button>
));
